import { transformDTODate } from "@skylab-shared/core";
import { Transform, Type } from "class-transformer";
import { CalculationMethod } from "../../common/calculation-method";
import { InventoryDocumentBuyerDTO, InventoryDocumentClientDTO } from "../../document/dto/document-client.dto";
import { DocumentExchangeRateDTO } from "../../document/dto/document-exchange-rate.dto";
import { DocumentVatTableDTO } from "../../document/dto/document-vat-table.dto";
import { InventoryCostCalculationMethod } from "../inventory-cost-calculation-method";
import { InventoryDocumentKind } from "../inventory-document-kind";
import { InventoryRelationshipCreationMethod } from "../inventory-relationship-creation-method";
import { InventoryGetDocumentItemDTO, InventoryUpdateDocumentItemDTO } from "./inventory-document-item.dto";

export class InventoryGoodsReceiptDocumentDTO {
	@Type(() => InventoryDocumentBuyerDTO) public supplier: InventoryDocumentBuyerDTO | null;
	public calculationMethod: CalculationMethod.Gross | CalculationMethod.Net;
	public costCalculationMethod: InventoryCostCalculationMethod;
	@Type(() => InventoryDocumentClientDTO) public seller: InventoryDocumentClientDTO | null;
	public currencyId: number;
	public documentNumber: string;
	@Type(() => DocumentExchangeRateDTO) public exchangeRate: DocumentExchangeRateDTO | null;
	public id: number;
	@Transform(transformDTODate, { toClassOnly: true }) public issueDate: Date | null;
	@Transform(transformDTODate, { toClassOnly: true }) public receiptDate: Date;
	public issuer: string | null;
	public kind: InventoryDocumentKind;
	public numberingId?: number;
	public recipient: string | null;
	public note: string | null;
	public transactionLocation: string | null;
	public duplicatePreventionId: string;
	public version: string;
	public inventoryId: number;
	public relatedCommercialDocuments: { id: number, version: string }[];
	public grossValue: number;
	public netValue: number;

	//adjustments
	public adjustedDocumentVersion?: string;
	public adjustedDocumentId?: number;
}

export class InventoryGetGoodsReceiptDocumentDTO extends InventoryGoodsReceiptDocumentDTO {
	@Type(() => InventoryGetDocumentItemDTO) public items: InventoryGetDocumentItemDTO[];
	@Type(() => DocumentVatTableDTO) public vatTable: DocumentVatTableDTO;
	public issuedByVatPayer: boolean;
	public baseCurrencyGrossValue: number;
	public baseCurrencyNetValue: number;
}

export class InventoryUpdateGoodsReceiptDocumentDTO extends InventoryGoodsReceiptDocumentDTO {
	@Type(() => InventoryUpdateDocumentItemDTO) public items: InventoryUpdateDocumentItemDTO[];
	public creationMethod: InventoryRelationshipCreationMethod;
}

